import React from "react";

//translation
import { useTranslation } from "react-i18next";

// @material-ui core components
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Box from "@mui/material/Box";
import { Avatar, Checkbox, Divider, Grid } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import UploadPersonImg from "UIComponents/UploadPersonImg";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

//assets
import colors from "assets/theme/base/colors";
import { styled } from "@mui/material/styles";
import pxToRem from "assets/theme/functions/pxToRem";

//icons
import { ReactComponent as DescIcon } from "assets/images/icons/desc.svg";
import { ReactComponent as ExitIcon } from "assets/images/icons/exit.svg";
import { ReactComponent as ProfileIcon } from "assets/images/icons/profile.svg";
import { ReactComponent as FaqIcon } from "assets/images/icons/faq.svg";

export const DashLine = styled("div")(({ theme }) => {
  const { palette } = theme;
  const { text } = palette;
  return {
    borderLeftColor: text.desc,
    borderLeftWidth: "2px",
    borderLeftStyle: "dashed",
    height: pxToRem(22),
  };
});
export const Dot = styled("div")(({ theme }) => {
  const { palette } = theme;
  const { text } = palette;
  return {
    backgroundColor: text.desc,
    height: pxToRem(8),
    width: pxToRem(8),
    borderRadius: "50%",
    marginRight: pxToRem(-3),
  };
});
function DashboardNavbar({}) {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorElHelp, setAnchorElHelp] = React.useState(null);

  const open = Boolean(anchorEl);
  const openHelp = Boolean(anchorElHelp);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleHelpClick = (event) => {
    setAnchorElHelp(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCloseHelpMenu = () => setAnchorElHelp(null);
  const { text } = colors;

  const renderHelpMenu = () => (
    <Menu
      anchorEl={anchorElHelp}
      anchorReference={null}
      open={Boolean(openHelp)}
      onClose={handleCloseHelpMenu}
      id="account-menu"
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
          mt: 1.5,
          padding: pxToRem(18),
          "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
          "&:before": {
            content: '""',
            display: "block",
            position: "absolute",
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: "background.paper",
            transform: "translateY(-50%) rotate(45deg)",
            zIndex: 0,
          },
        },
      }}
      transformOrigin={{ horizontal: "left", vertical: "top" }}
      anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
    >
      <MDBox px={2} display="flex" justifyContent="center">
        <MDTypography fontSize="sm">{t("buttons.guide")}</MDTypography>
      </MDBox>
      <Divider />
      <MDBox px={2} display="flex" justifyContent="center">
        <MDTypography fontSize="sm">{t("buttons.sendComment")}</MDTypography>
      </MDBox>
    </Menu>
  );

  const renderProfile = () => (
    <Menu
      anchorEl={anchorEl}
      id="account-menu"
      open={open}
      onClose={handleClose}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
          mt: 1.5,
          padding: pxToRem(18),
          "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
          "&:before": {
            content: '""',
            display: "block",
            position: "absolute",
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: "background.paper",
            transform: "translateY(-50%) rotate(45deg)",
            zIndex: 0,
          },
        },
      }}
      transformOrigin={{ horizontal: "left", vertical: "top" }}
      anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
    >
      <Grid container>
        <Grid item>
          <UploadPersonImg />

          <DashLine />
          <MDBox display="flex" ml={-0.3} alignItems="center" mt={-0.5}>
            <Dot />
            <DescIcon style={{ marginRight: "8px" }} />
            <MDTypography
              component="p"
              ml={1}
              fontSize="xs"
              color="text"
              sx={{ color: text.label }}
            >
              {t("labels.phone")}
            </MDTypography>
            <MDTypography component="p" ml={1}>
              09123355667
            </MDTypography>
          </MDBox>
        </Grid>
        <Grid item ml={-18}>
          <MDTypography fontSize="sm" sx={{ textAlign: "left" }} fontWeight="bold">
            تستی تستی
          </MDTypography>
          <MDTypography
            color="text"
            fontSize="xs"
            sx={{ textAlign: "left", color: text.desc, mt: 1 }}
          >
            کاربرعادی
          </MDTypography>
        </Grid>
      </Grid>
      <Divider />
      <Grid container spacing={0.2} justifyContent="center" alignItems="center">
        <Grid item>
          <Avatar
            variant="square"
            sx={{ borderRadius: "10.5px", width: "40px !important", height: "40px !important" }}
          />
        </Grid>
        <Grid item>
          <MDTypography fontSize="sm" sx={{ textAlign: "center" }} fontWeight="bold">
            تستی تستی
          </MDTypography>
          <MDTypography fontSize="xs" sx={{ textAlign: "center" }}>
            09123456789
          </MDTypography>
        </Grid>
        <Grid item alignItems="baseline" width="8rem">
          <MDTypography fontSize="xs" sx={{ textAlign: "center", color: text.desc }}>
            کاربر عادی
          </MDTypography>
        </Grid>
        <Grid item>
          <Checkbox />
        </Grid>
      </Grid>
      <Divider />
      <MDTypography fontSize="sm" color="success" sx={{ textAlign: "center", mb: 3 }}>
        {t("buttons.newAccount")}
      </MDTypography>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <MDButton
            href="/authentication/sign-in"
            color="error"
            variant="text"
            startIcon={<ExitIcon />}
          >
            {t("buttons.exit")}
          </MDButton>
        </Grid>
        <Grid item>
          <MDButton variant="text" sx={{ color: text.desc }}>
            {t("buttons.rule")}
          </MDButton>
        </Grid>
      </Grid>
    </Menu>
  );

  return (
    <Box
      sx={({ breakpoints }) => ({
        display: "flex",
        alignItems: "center",
        textAlign: "left",
        justifyContent: "end",
        [breakpoints.up("sm")]: {
          marginTop: "-27px",
          marginRight: "48px",
        },
        [breakpoints.down("sm")]: {
          marginTop: "-27px",
          marginRight: "48px",
        },
        [breakpoints.up("lg")]: {
          marginTop: "0px",
          marginRight: "0px",
        },
      })}
    >
      <IconButton
        onClick={handleHelpClick}
        size="small"
        sx={{ ml: 2 }}
        aria-controls={openHelp ? "account-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={openHelp ? "true" : undefined}
      >
        <FaqIcon />
      </IconButton>
      <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 2 }}
        aria-controls={open ? "account-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        <ProfileIcon />
      </IconButton>
      {renderProfile()}
      {renderHelpMenu()}
    </Box>
  );
}
export default DashboardNavbar;
